import axios from 'axios'

const http = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'XX-Api-Version': '1.0', // 固定值
        'Accept-Language': 'zh-cn' // 默认值
    }
});


// 请求拦截器
http.interceptors.request.use(config => {
    const token = localStorage.getItem('authToken')
    if (token) {
        config.headers['XX-Token'] = token;
    }
    // 添加 XX-Device-Type
    config.headers['XX-Device-Type'] = getDeviceType();

    return config
}, error => {
    return Promise.reject(error)
})

// 响应拦截器
http.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code === 10001) {
            // 删除 token 并跳转
            localStorage.removeItem('authToken')
            localStorage.removeItem('userInfo')
            window.location.href = '/login'
            return false;
        }
        return res
    },
    error => {
        // HTTP 状态码拦截
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    console.error('未授权，请重新登录')
                    break
                case 403:
                    console.error('拒绝访问')
                    break
                case 500:
                    console.error('服务器错误')
                    break
                default:
                    console.error('请求错误')
            }
        } else {
            console.error('网络异常或服务器无响应')
        }
        return Promise.reject(error)
    }
)

// 获取设备类型
export  function getDeviceType() {
    // const userAgent = navigator.userAgent.toLowerCase();

    // if (/mobile/.test(userAgent)) {
    //     return 'mobile';
    // }
    // if (/android/.test(userAgent)) {
    //     return 'android';
    // }
    // if (/iphone/.test(userAgent)) {
    //     return 'iphone';
    // }
    // if (/ipad/.test(userAgent)) {
    //     return 'ipad';
    // }
    // if (/micromessenger/.test(userAgent)) {
    //     return 'wxapp'; // 微信小程序
    // }
    // if (/macintosh/.test(userAgent)) {
    //     return 'mac';
    // }
    // if (/windows/.test(userAgent)) {
    //     return 'pc';
    // }
    return 'web'; // 默认值
}
export default http
